let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let esUtils = require("ES/utils/esUtils");
let FormUtils = require("../../../../../utils/FormUtils");
let ezHorizontalFields = require("react-loose-forms.bootstrap3/layouts/ezHorizontalFields");
let HorizontalFieldSpot = require("react-loose-forms.bootstrap3/layouts/HorizontalFieldSpot");
let createStandardEventForm = require("../../createStandardEventForm");

let mkTrackingURL = function(tracking_number){
	return esUtils.isBlank(tracking_number) ? null : "https://www.google.com/search?q=" + tracking_number;
};

module.exports = createStandardEventForm({
	eventToInitialValues(event){
		return {
			productQtyBoxes: event.productQtyBoxes,
			productShipper: event.productShipper,
			productTrackingNumbers: event.productTrackingNumbers
		};
	},
	buildSchema(){
		return {
			productQtyBoxes: {
				label: "Qty Boxes",
				type: "text",
				validate: FormUtils.v.blankOr(FormUtils.v.positive_integer)
			},
			productShipper: {
				label: "Shipper",
				type: "select",
				placeholder: "--",
				dont_sort_options: true,
				options: _.object(_.map(["DHL", "FEDEX", "UPS", "USPS", "carry with", "other"], function(v){
					return [v, v];
				})),
				validate: FormUtils.v.optional
			},
			productTrackingNumbers: {
				label: "Tracking Numbers",
				type: "text",
				validate: FormUtils.v.optional
			}
		};
	},
	writeInputDataToEvent(data, event){
		event.productQtyBoxes = esUtils.isBlank(data.productQtyBoxes) ? null : esUtils.toInt(data.productQtyBoxes);
		event.productShipper = data.productShipper;
		event.productTrackingNumbers = data.productTrackingNumbers;
	},
	renderFields(){
		let {data} = this.state;
		let tracking_url = mkTrackingURL(data && data.productTrackingNumbers);
		return dd.div(null,
			ezHorizontalFields(this),
			tracking_url
				? HorizontalFieldSpot(null, dd.a({href: tracking_url, target: "_blank"}, "Live Tracking"))
				: null
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/services/PackagesForm.js